import { useState } from 'react';
import { chatbotApi } from '../../api/endpoints';
import type { ConverseDraft, ConverseResult } from '../../types';
import type { AiTurn } from './chatSteps';

/**
 * Bọc `chatbotApi.converse` để ChatbotWidget không phải tự quản lý state
 * "đang chờ AI trả lời" — tách riêng khỏi widget vì đây là nghiệp vụ (gọi
 * API, bật/tắt cờ loading), không phải trình bày (render).
 */
export function useAiConversation() {
  const [sending, setSending] = useState(false);

  const send = async (turns: AiTurn[], draft: ConverseDraft, turnsUsed: number): Promise<ConverseResult> => {
    setSending(true);
    try {
      return await chatbotApi.converse({ turns, draft, turnsUsed });
    } catch {
      // Lỗi mạng/HTTP (khác với lỗi AI nội bộ mà backend đã tự biến thành
      // action='unavailable' với HTTP 200) — vẫn phải trả một ConverseResult
      // hợp lệ để ChatbotWidget có một luồng xử lý DUY NHẤT, không cần try/catch
      // riêng ở nơi gọi.
      return { action: 'unavailable', message: '', draft, turns_left: 0 };
    } finally {
      setSending(false);
    }
  };

  return { sending, send };
}
